import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDropdownItem } from '@ux/menu/dropdown';

const NavItem = React.forwardRef(({ as: Comp = 'div', isLink, href, active, children, ...rest }, forwardedRef) => {
  const {
    data: { isSelected },
    props
  } = useDropdownItem({ isLink: isLink ?? !!href, ...rest, ref: forwardedRef });

  const { className, ...sharedProps } = props;
  const cx = classnames('ux-menu-item', {
    className: !!className
  });

  if (href && Comp === 'div') {
    Comp = 'a';
  }

  return (
    <Comp className={ cx } href={ href } { ...sharedProps } data-selected={ active || isSelected ? 'true' : undefined }>
      {children}
    </Comp>
  );
});

NavItem.propTypes = {
  as: PropTypes.elementType,
  isLink: PropTypes.bool,
  href: PropTypes.string,
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string
};

export default NavItem;
